import { defineMessages } from "react-intl";
const messages = defineMessages({
    insightsPermissionLabel: {
        id: "app.users.createUser.insights.label.text",
        defaultMessage: "Select insights permission",
    },
    insightsPermissionOptionView: {
        id: "app.users.createUser.insights.option.view.text",
        defaultMessage: "Grant Access",
    },
    insightsPermissionOptionDeny: {
        id: "app.users.createUser.insights.option.deny.text",
        defaultMessage: "No Access",
    },
});
export default messages;
